import styled from 'styled-components'
import rem from '../../../../../styles/tools/rem'

import { txt16OpenSansBold, txt16OpenSans } from '../../../../../styles/settings/types'
import { darkSlateBlue, skyBlue, paleGray } from '../../../../../styles/settings/colors'

export const FormsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Separator = styled.hr`
  border-top: 2px solid ${paleGray};
  width: 100%;
  margin: 0;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  background-color: ${darkSlateBlue};
  height: ${rem('100px')};
  align-items: center;
  justify-content: center;
  display: flex;
`

export const InputsContainer = styled.div`
  width: ${rem('940px')};
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`

export const Grid = styled.div`
  width: ${rem('940px')};
  display: flex;
  justify-content: space-between;
`

export const ShowResultsBtnWrapper = styled.div`
  width: ${rem('940px')};
  display: flex;
  justify-content: flex-end;
  margin: ${rem('30px')} 0;
`

export const ShowResultsFormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const FormButton = styled.button`
  background-color: ${skyBlue};
  color: white;
  ${txt16OpenSansBold};
  padding: ${rem('13px')} ${rem('25px')};
  border-radius: 25px;
  margin-left: ${rem('20px')};
  border-width: 0;
  ${({ invalid }) => !invalid && `cursor: pointer;`};
  ${({ invalid }) => invalid && `opacity: 0.5;`};
`

export const ShowResultsInput = styled.input`
  border: none;
  border-bottom: 3px solid ${darkSlateBlue};
  background-color: ${paleGray};
  padding: ${rem('16px')};
  line-height: ${rem('24px')};
  color: ${darkSlateBlue};
  ${txt16OpenSans};
  width: 100%;
  margin: 0 ${rem('10px')};
  &:first-of-type {
    margin: 0;
    margin-right: ${rem('10px')};
  }
  &:last-of-type {
    margin: 0;
    margin-left: ${rem('10px')};
  }
`

export const ResetButton = styled.button`
  color: ${({ showResults }) => (showResults ? darkSlateBlue : `white`)};
  ${txt16OpenSansBold};
  border-width: 0;
  border-bottom: 2px solid ${({ showResults }) => (showResults ? darkSlateBlue : `white`)};
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/styles.js